import AsoHeader from "../../../components/Aso/Header";
import DocumentoAssinado from "../../../components/Aso/Register/AsoDocumentoAssinado";

const AsoDocumentoAssinado = () => {
    return(
        <>
            <AsoHeader />
            <DocumentoAssinado />
        </>
    );
}

export default AsoDocumentoAssinado;